/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ValueDefaults } from './ValueDefaults';
import {
    ValueDefaultsFromJSON,
    ValueDefaultsFromJSONTyped,
    ValueDefaultsToJSON,
} from './ValueDefaults';

/**
 * 
 * @export
 * @interface HydratedIntegrationWriteObject
 */
export interface HydratedIntegrationWriteObject {
    /**
     * 
     * @type {string}
     * @memberof HydratedIntegrationWriteObject
     */
    objectName: string;
    /**
     * 
     * @type {string}
     * @memberof HydratedIntegrationWriteObject
     */
    displayName: string;
    /**
     * 
     * @type {ValueDefaults}
     * @memberof HydratedIntegrationWriteObject
     */
    valueDefaults?: ValueDefaults;
}

/**
 * Check if a given object implements the HydratedIntegrationWriteObject interface.
 */
export function instanceOfHydratedIntegrationWriteObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectName" in value;
    isInstance = isInstance && "displayName" in value;

    return isInstance;
}

export function HydratedIntegrationWriteObjectFromJSON(json: any): HydratedIntegrationWriteObject {
    return HydratedIntegrationWriteObjectFromJSONTyped(json, false);
}

export function HydratedIntegrationWriteObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): HydratedIntegrationWriteObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectName': json['objectName'],
        'displayName': json['displayName'],
        'valueDefaults': !exists(json, 'valueDefaults') ? undefined : ValueDefaultsFromJSON(json['valueDefaults']),
    };
}

export function HydratedIntegrationWriteObjectToJSON(value?: HydratedIntegrationWriteObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objectName': value.objectName,
        'displayName': value.displayName,
        'valueDefaults': ValueDefaultsToJSON(value.valueDefaults),
    };
}

